/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.18 public/Invessoft.glb 
*/

// import React, { useRef } from 'react'
import { extend, useFrame, useThree } from '@react-three/fiber'
import { Effects, OrbitControls, Reflector, useGLTF } from '@react-three/drei'
import { Color } from 'three'
import { useEffect, useRef, useState } from 'react'
import { UnrealBloomPass } from 'three/examples/jsm/Addons.js'
import useMousePosition from '../../hooks/mouse-position'
import useWindowDimensions from '../../hooks/dimensions'

extend({ UnrealBloomPass })

export function Invessoft(props) {



  const { nodes, materials } = useGLTF('./Invessoft.glb')
  const camera = useThree(state => state.camera)
  const scene = useThree(state => state.scene)
  const { width } = useWindowDimensions();
  const { x, y } = useMousePosition()

  const sphereRef = useRef();

  useEffect(()=>{          
    camera.position.set(0, 7, 15)
    camera.lookAt(0, 1, 0)
    //camera.rotateX(-1, 0, 0)
    camera.fov = 45;
    camera.setViewOffset(camera.getFilmWidth(),  camera.getFilmHeight(), -10, 0,  camera.getFilmWidth(), camera.getFilmHeight() )  
    camera.updateProjectionMatrix();    
    scene.background = new Color( "#ce0007" );
  },[])

  useFrame(() => {
    sphereRef.current.rotation.y =  + (((x??0)-(width/2)))/2000
    sphereRef.current.rotation.x = -(((y??0)-(width/2)))/7000
    //generateRotation()       
    // camera.rotateY(dx?dx/200:0)    
    // camera.position.set(0, 0.7 + (dy?dy/7:0), 0)

  })

  return (
    <group {...props} dispose={null}>
      <Effects disableGamma>
        <unrealBloomPass threshold={0.5} strength={0.12} radius={0.1} />               
      </Effects>
      {/* <pointLight position={[-5, 7, -9]} intensity={100} color="#FF00F4" />   */}
      <ambientLight intensity={3} color="#FF5050" />
      
      <mesh ref={sphereRef} geometry={nodes.Sphere.geometry} material={materials['White Glow']} rotation={[0, 0, 0]} />

        <Reflector
        resolution={1024}
        rotation={[-Math.PI / 2, 0, 0]}
        position={[0, -1, 0]}
        args={[200, 200]}
        mirror={0}  // Adjust this value for the strength of the mirror effect
        mixBlur={200}  // Higher values for more blur
        mixStrength={0.25}  // Adjust the mix strength of the blur and reflection
        depthScale={1}
        minDepthThreshold={0.5}
        maxDepthThreshold={3}
        depthToBlurRatioBias={0.2}
        distortion={0}
        reflectorOffset={0.2}
      >
      {(Material, props) => (
        <Material color="#ce2027" metalness={0} roughness={0.5} {...props} />
      )}
    </Reflector>
    <OrbitControls />
    </group>
  )
}

useGLTF.preload('./Invessoft.glb')
